import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import CreateAccount from '@/views/CreateAccount.vue'
import Dashboard from '@/views/Dashboard.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import UpdatePassword from '@/views/UpdatePassword.vue'
import SettingsGeneral from '@/views/SettingsGeneral.vue'
import SettingsAppearance from '@/views/SettingsAppearance.vue'
import SettingsUsers from '@/views/SettingsUsers.vue'
import SettingsGroups from '@/views/SettingsGroups.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: 'Login',
        requires: [ 'unauth' ]
      }
    },
    {
      path: '/create-account/:hash?',
      name: 'create-account',
      component: CreateAccount,
      meta: {
        title: 'Create Account',
        requires: [ 'unauth' ]
      }
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
      meta: {
        title: 'Forgot Password',
        requires: [ 'unauth' ]
      }
    },
    {
      path: '/reset-password/:hash?',
      name: 'reset-password',
      component: ResetPassword,
      meta: {
        title: 'Reset Password',
        requires: [ 'unauth' ]
      }
    },
    {
      path: '/update-password',
      name: 'update-password',
      component: UpdatePassword,
      meta: {
        title: 'Update Password',
        requires: [ 'auth' ]
      }
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'dashboard-redirect',
      component: Dashboard,
      meta: {
        title: 'Dashboard',
        requires: [ 'auth' ]
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: 'Dashboard',
        requires: [ 'auth' ]
      }
    },
    {
      path: '/settings/general',
      name: 'settings-general',
      component: SettingsGeneral,
      meta: {
        title: 'Settings: General',
        is: [ 'settings' ],
        requires: [ 'auth', 'admin' ]
      }
    },
    {
      path: '/settings/appearance',
      name: 'settings-appearance',
      component: SettingsAppearance,
      meta: {
        title: 'Settings: Appearance',
        is: [ 'settings' ],
        requires: [ 'auth', 'admin' ]
      }
    },
    {
      path: '/settings/users',
      name: 'settings-users',
      component: SettingsUsers,
      meta: {
        title: 'Settings: Users',
        is: [ 'settings' ],
        requires: [ 'auth', 'admin' ]
      }
    },
    {
      path: '/settings/groups',
      name: 'settings-groups',
      component: SettingsGroups,
      meta: {
        title: 'Settings: Groups',
        is: [ 'settings' ],
        requires: [ 'auth', 'admin' ]
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js